import script from "./AvisoNuevaVersion.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisoNuevaVersion.vue?vue&type=script&setup=true&lang=js"

import "./AvisoNuevaVersion.vue?vue&type=style&index=0&id=f49996d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f49996d8"]])

export default __exports__